/* vDEV */
(() => {

  const obj = {
    templates: {}
  };

  obj.init = () => {

    if (document.body.classList.contains('template-collection')) {
      obj.templates.collection.init();
    }
  };

  obj.templates.collection = {
    
    init: () => {
      obj.templates.collection.quickAddToCart();
      obj.templates.collection.sidebarFilters();
    },
    
    quickAddToCart: () => {
      
      class QuickAddToCart extends HTMLElement {
  
        settings = {
          form: this.querySelector('form'),
          bg: this.querySelector('.grid-product__quick-add-to-cart__bg'),
          button: this.querySelector('button')
        }
  
        constructor() {
          super();
          
          const obj3 = this;
          
          obj3.event();
        }
  
        event() {
          const obj3 = this;
  
          obj3.settings.button.addEventListener('click', () => {
            obj3.ajaxSubmit();
          });
        }
  
        ajaxSubmit() {
          const obj3 = this;
  
          obj3.classList.add('is-added');
          obj3.settings.button.setAttribute('disabled', 'disabled');
  
          const cartDot = document.querySelector('.cart-link__bubble');

          if (cartDot) {
            cartDot.classList.add('cart-link__bubble--visible');
          }
  
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: obj3.getAttribute('data-variant-id'),
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            obj3.settings.button.removeAttribute('disabled');

            setTimeout(() => {
              obj3.classList.remove('is-added');
            }, 3000);
          });
        }
      }
      
      customElements.define('quick-add-to-cart', QuickAddToCart);
    },
    
    sidebarFilters: () => {
      obj.templates.collection.sidebarFilters__event();

      window.addEventListener('resize', () => {
        obj.templates.collection.sidebarFilters__event();
      });

      window.addEventListener('scroll', () => {
        obj.templates.collection.sidebarFilters__event();
      });
    },
    
    sidebarFilters__event: () => {
      
      const stickySidebar = document.querySelector('.grid__item--sidebar');

      if (!stickySidebar) {
        return false;
      }
      
      const stickySidebar__offsetTop = stickySidebar.getBoundingClientRect().top;

      const header = document.querySelector('.header-sticky-wrapper');
      const header__height = header.offsetHeight;
      const header__offsetTop = header.getBoundingClientRect().top;
      
      let stickySidebar__height = window.innerHeight - header__offsetTop - header__height;

      if (header__offsetTop > 0) {
        stickySidebar__height -= 45;
      }
      
      stickySidebar.style.setProperty('--height', `${stickySidebar__height}px`);
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    obj.init();
  });
  
})();
/* /vDEV */